import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { testimonials } from '../../data/salesContent';
export function TestimonialsSection() {
  return <section className="bg-ink-soft px-5 py-20 md:py-28" data-id="element-197" data-mp="1ruw97dvq5s0i">
      <div className="mx-auto max-w-6xl" data-id="element-198" data-mp="1rtbcpipunz00">
        <SectionHeading title="Lo que dicen los instructores" data-id="element-199" data-mp="1mxcukcv47d81" />
        <ul className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-200" data-mp="1iuzpzrs3tlcu">
          {testimonials.map(t => <li key={t.author} className="flex flex-col rounded-3xl border border-gold/30 bg-ink p-7" data-id="element-201" data-mp="1isn26xzo0grv">
              <div className="flex items-center gap-4" data-id="element-202" data-mp="18wtr7j1lgvc7">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gold font-display text-base font-black text-black" data-id="element-203" data-mp="18xbu2yiri7t3">
                  {t.initials}
                </span>
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-204" data-mp="33a1p5jkv9n22">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-205" data-mp="1t9wwtxqpobn9" data-mpi={i} />)}
                </div>
              </div>
              <blockquote className="mt-5 text-lg leading-relaxed text-cream" data-id="element-206" data-mp="1ya1dpovj78e0">“{t.quote}”</blockquote>
              <p className="mt-auto pt-6 text-sm font-semibold text-neutral-400 md:text-base" data-id="element-207" data-mp="1jdaaf4iqlcj4">— {t.author}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}